import React from 'react';
interface SkeletonProps {
  className?: string;
}
export function Skeleton({
  className = ''
}: SkeletonProps) {
  return <div className={`bg-stone-200 dark:bg-stone-700 animate-pulse ${className}`} data-id="element-1960" />;
}